<template>
  <div class="hxjl">
    <!-- 核销记录 -->
    <van-nav-bar
        title=""
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />



    <div class="main">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="getmore"
            >
            <div class="infobox" v-for="(item,index) in dataList" :key="index" @click="gotoXq(item.id)">
                <div class="yyrq" data-flex>
                    <div class="left">
                        <div class="yy">预约日期：</div>
                        <div class="rq">{{item.date}}</div>
                    </div>
                    <div class="rightr">
                        申请编号：{{item.serialNumber || '******'}}
                    </div>
                </div>
                <div class="sqdw" data-flex>
                    <div class="sq">申请单位：</div>
                    <div class="dw">{{item.applicantName}}</div>
                </div>
                <div class="ldxm" data-flex>
                    <div class="ld">领队姓名：</div>
                    <div class="xm">{{item.realname}}</div>
                </div>
                <div class="yyrs" data-flex>
                    <div class="yy">预约人数：</div>
                    <div class="rs">{{item.population}}</div>
                </div>
                <div class="sbrq" data-flex>
                    <div class="yy">申报日期：</div>
                    <div class="rq">{{item.vtime}}</div>
                </div>
            </div>
            
        </van-list>
    </div>
  </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { List, NavBar} from 'vant'
export default {
    name:"HexiaoList",
    mixins: [mix1],
    components: {
        [List.name]: List,
        [NavBar.name]: NavBar
    },
    
    data(){
        return{
            x:100,
            y:10,
            dataList:[
            //     {
            //     yyrq:"2024-11-11",
            //     sqdw:"海天味业",
            //     ldxm:"萧丽",
            //     yyrs:10,
            //     sbrq:"2024-11-11"
            // },
            // {
            //     yyrq:"2024-11-11",
            //     sqdw:"上海电气",
            //     ldxm:"方平",
            //     yyrs:10,
            //     sbrq:"2024-11-11"
            // },
            // {
            //     yyrq:"2024-11-11",
            //     sqdw:"常山北明",
            //     ldxm:"杨明",
            //     yyrs:10,
            //     sbrq:"2024-11-11"
            // },
        ],
        loading: false,
        finished: false,

        page:1,
        pageSize:10
        }
    },
    methods: {
        onClickLeft(){
            this.$router.go(-1);
        },
        gotoXq(x){
            this.$router.push('/ercode/hexiaoXq?id='+`${x}`)
        },
        getmore(){
            if(this.dataList.length < 10){
                return
            }
            this.page++;
            let data = {};
            data.page = this.page;
            data.pageSize = this.pageSize;
            const promise = this.apiGet('hexiaoList',data)
            let apiResult = null
            try {
                apiResult = promise
            } catch (ex) {
                apiResult = null
            }
            if (this.isEmpty(apiResult)) {
                this.finished = true;
                return
            }
            this.dataList = this.dataList.concat(apiResult.list);
            if(apiResult.list.length < 10){
                    this.finished = true;
                }
            console.log("this.dataList=>",this.dataList);
             // 加载状态结束
            this.loading = false;
        },
          async getList(){
                uiShowLoading();
                let data = {};
                data.page = this.page;
                data.pageSize = this.pageSize;
                const promise = this.apiGet('hexiaoList',data)
                let apiResult = null
                try {
                    apiResult = await promise
                } catch (ex) {
                    apiResult = null
                }
                if (this.isEmpty(apiResult)) {
                    this.finished = true;
                    return
                }
                this.dataList = apiResult.list;
                if(apiResult.list.length < 10){
                    this.finished = true;
                }
                uiHideLoading();
                console.log("this.dataList=>",this.dataList);
            },
        },

        created(){
            this.getList()
        }
    }

</script>

<style lang="less" scoped>
.main{
    margin-top: 20px;
        .infobox{
            margin: 0 auto;
            border: 1px solid transparent;
            width: 710px;
            height: 350px;
            background: #FFFFFF;
            border-radius: 15px 15px 15px 15px;
            margin-bottom: 10px;
            padding: 8px;
            box-sizing: border-box;
            .yyrq{
                margin-left: 20px;
                margin-top: 30px;
                display: flex;
                justify-content: space-between;
                .left{
                    display: flex;
                    .yy{
                        // width: 308px;
                        height: 40px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #030303;
                        line-height: 40px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                    .rq{
                        height: 40px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #030303;
                        line-height: 40px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                    
                }
                .right{
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
            .sqdw{
                margin-left: 20px;
                margin-top: 24px;
                .sq{
                    // width: 140px;
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 14px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
                .dw{
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 14px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
            .ldxm{
                margin-left: 20px;
                margin-top: 18px;
                .ld{
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 14px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
                .xm{
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 14px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
            .yyrs{
                margin-left: 20px;
                margin-top: 18px;
                .yy{
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 14px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
                .rs{
                    // width: 43px;
                    height: 50px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 18px;
                    color: #FD4A46;
                    line-height: 50px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
            .sbrq{
                margin-left: 20px;
                margin-top: 34px;
                .sb{
                    // width: 308px;
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
                .rq{
                    height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #030303;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
            }
        }
</style>